export default class InternalTableColumn {
    constructor (dto) {
        this.name = ''
        this.order = 0
        this.relatedTableId = ''
        this.relatedTable = ''
        this.linkableColumn = false
        this.isRequired = false

        if (dto) {
            this.name = dto.Name
            this.order = dto.Order
            if (dto.RelatedTableID) {
                this.relatedTableId = dto.RelatedTableID + ''
            }
            this.relatedTable = dto.RelatedTable
            this.linkableColumn = dto.LinkableColumn
            this.isRequired = dto.IsRequired
        }
    }

    toDto () {
        return {
            Name: this.name,
            Order: this.order,
            RelatedTableID: this.relatedTableId,
            RelatedTable: this.relatedTable,
            LinkableColumn: this.linkableColumn,
            IsRequired: this.isRequired,
        }
    }
}
